const localInformationSchema = {
  content: [],
};

export default localInformationSchema;
